export var SPACING_UNITS = {
    0: 0,
    1: 4,
    2: 8,
    3: 16,
    4: 24,
    5: 32,
    6: 40,
    7: 48,
    8: 64,
    9: 72,
    10: 96,
    11: 120
};
/**
 * Convert a spacing scale to a pixel value. This is a wrapper
 * function that we can use to avoid hard-coding pixel values in
 * styled components.
 *
 * NOTE: There is the possibility to use UDS `useSpacingScale` hook
 *  but this is currently not preferable due to excess code bloat needed
 *  in the component which then needs to be prop-drilled to styled components.
 *
 * @param {number} scale
 * @returns {string} - pixel value (eg. 1 => 4px)
 */
export var space = function (scale) {
    var scaleInRange = scale > 0 && scale < 12 ? scale : 0;
    return SPACING_UNITS[scaleInRange] || 0;
};
export default space;
